import { ConnectionEvents } from '../globals/constant';
export class ConnectionAvailableEvent {
    constructor(connectionId) {
        this.name = ConnectionEvents.ConnectionAvailable;
        this.connectionId = connectionId;
    }
}
